import { memo } from 'react';
import { Badge } from 'react-bootstrap';
import { FaTruckFast } from 'react-icons/fa6';

import ShippingFiltersText from '@/resources/components/product/freeShippingAlert/rulesModal/ShippingFiltersText';
import { formatDate } from '@/services/dates';
import { maskMoney } from '@/services/global';
import { IDeliveryDiscountData } from '@/store/ducks/deliveryDiscount/types';

interface Props {
  discount: IDeliveryDiscountData;
}

function getDiscountDescription(params: {
  type_discount: string;
  min_price_order: number;
  price_discount: number;
  hasDiscount: boolean;
  discount: IDeliveryDiscountData;
  hasDate: boolean;
  start_date: string;
  end_date: string;
  max_distance: number;
}) {
  const {
    type_discount,
    min_price_order,
    price_discount,
    hasDiscount,
    discount,
    hasDate,
    start_date,
    end_date,
    max_distance,
  } = params;

  if (!['free', 'price'].includes(type_discount)) return null;

  if (min_price_order === 0) {
    if (type_discount === 'free') {
      return (
        <>
          <>FRETE GRÁTIS válido para pedidos com endereço de entrega de até {max_distance}km.</>
          {hasDate && (
            <>
              Pedidos devem ser realizados no período de <b>{formatDate(start_date)}</b> a{' '}
              <b>{formatDate(end_date)}</b>
            </>
          )}
          {hasDiscount && ' e que contenham itens '}
          {hasDiscount && <ShippingFiltersText discount={discount} showPhrases={true} />}
        </>
      );
    }
    return (
      <>
        Desconto exclusivo no frete para pedidos com endereço de entrega de até {max_distance}km
        {hasDate && (
          <>
            Pedidos devem ser realizados no período de <b>{formatDate(start_date)}</b> a{' '}
            <b>{formatDate(end_date)}</b>
          </>
        )}
        {hasDiscount && ' e que contenham itens '}
        {hasDiscount && <ShippingFiltersText discount={discount} showPhrases={true} />}.
      </>
    );
  }

  return (
    <>
      {type_discount === 'free' ? (
        <>
          FRETE GRÁTIS válido para pedidos com valor acima de{' '}
          <b>R$ {maskMoney(min_price_order, true)} </b>
          (em produtos){' '}
        </>
      ) : (
        <>
          Desconto exclusivo no frete no valor de <b>{maskMoney(price_discount, true)} </b>
          para pedidos com valor acima de <b>R$ {maskMoney(min_price_order, true)}</b> (em produtos){' '}
        </>
      )}
      {hasDiscount && ' e que contenham itens '}
      {hasDiscount && <ShippingFiltersText discount={discount} showPhrases={true} />}{' '}
      {hasDate && (
        <>
          Pedidos devem ser realizados no período de <b>{formatDate(start_date)}</b> a{' '}
          <b>{formatDate(end_date)}</b>
        </>
      )}
      {hasDate ? ' e com' : ' Com'} endereço de entrega de até <b>{max_distance}km.</b>
    </>
  );
}

function DeliveryDiscountItem({ discount }: Props) {
  const {
    type_discount,
    start_date,
    end_date,
    min_price_order,
    max_distance,
    price_discount,
    use_validity_range_config,
    use_product_filters,
  } = discount;

  const hasDiscount = Boolean(
    use_product_filters &&
      (discount?.brand || discount?.categories?.length || discount?.groups?.length),
  );

  const hasDate = Boolean(use_validity_range_config && start_date && end_date);

  return (
    <div className="coupon-card">
      <div className="coupon-card-header">
        <div className={`coupon-title`}>
          <FaTruckFast />
          <Badge className={`coupon-badge ${type_discount}-badge`}>
            {type_discount === 'free' ? 'FRETE GRÁTIS' : 'DESCONTO'}
          </Badge>
        </div>
      </div>

      <div className="coupon-card-body">
        <div className="coupon-description">
          <b>Regulamento: </b>
          {getDiscountDescription({
            type_discount,
            min_price_order,
            price_discount,
            hasDiscount,
            discount,
            hasDate,
            start_date,
            end_date,
            max_distance,
          })}
        </div>
      </div>
      <div className="coupon-notch coupon-notch-left" />
      <div className="coupon-notch coupon-notch-right" />
    </div>
  );
}

export default memo(DeliveryDiscountItem);
